/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UF = {
  type: 'Enum',
} as const;
